/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class GcpBigQueryTableDetails {
    getFixupPrototypeFunction() { return GcpBigQueryTableDetails.fixupPrototype; }

    static newInstance(model: Partial<GcpBigQueryTableDetails>): GcpBigQueryTableDetails {
        let obj = Object.assign(new GcpBigQueryTableDetails(), model);
        GcpBigQueryTableDetails.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<GcpBigQueryTableDetails>): GcpBigQueryTableDetails {
        if (!model) return null;
        return GcpBigQueryTableDetails.newInstance(<GcpBigQueryTableDetails> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: GcpBigQueryTableDetails) {
        if (!obj) return;

        models.GcpBigQueryTableDetails.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: GcpBigQueryTableDetails): boolean {
        Object.setPrototypeOf(obj, GcpBigQueryTableDetails.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * BigQuery table id
     */
    table_id: string;

}
